export class ConversionTableValue {
    ValueId?: number;
    ColumnId?: number;
    RowId?: number;
    Value: string;
}